import Link from "next/link";
import cx from "classnames";
import Image from "next/image";

const Card = ({ cardRows = [] }) => {
  const wrapperDivClass = cx(
    "relative w-full md:w-[315px] lg:w-[290px] mx-auto  bg-white shadow-[2px_2px_5px_0_#aaa]",
    "md:min-h-[390px] lg:min-h-[415px]",
    "lg:[&:nth-child(2)]:mt-[70px]",
    "lg:[&:nth-child(2)]:min-h-[380px]",
    "lg:[&:nth-child(5)]:mt-[5px]",
    "lg:[&:nth-child(5)]:min-h-[427px]",
    "lg:[&:nth-child(4)]:min-h-[390px]",
    "lg:[&:nth-child(4)]:mt-[-35px]",
    "lg:[&:nth-child(6)]:min-h-[390px]",
    "lg:[&:nth-child(6)]:mt-[-35px]"
  );
  const renderCards = field => {
    const { fields = {} } = field;
    const { heading = "", image = {} } = fields;
    const { assets = {} } = image.fields || {};
    const assetFields = assets?.[0]?.fields ?? {};

    return (
      <article className="pb-0 md:pb-2 cursor-pointer">
        <figure className="w-full">
          <Image
            src={image?.fields?.imageUrl || assetFields?.file?.url}
            alt={image?.fields?.alt || assetFields?.file?.title || "Card Image"}
            width={0}
            height={0}
            className="w-full h-auto object-cover "
          />
        </figure>
        <div className="text-part w-full">
          {heading ? (
            <h4
              className={`text-lg md:text-2xl px-5 md:p-5  text-white md:text-[#333333] m-auto  cursor-pointer font-medium font-helveticaLight text-left md:text-center`}
            >
              {heading}
            </h4>
          ) : null}
          {fields?.paragraphText ? (
            <h5
              className={`pt-0 pr-5 md:pr-9 pb-3 text-white md:text-[#666] font-helveticaLight text-left md:text-center pl-5 md:pl-9`}
            >
              {fields?.paragraphText}
            </h5>
          ) : null}
        </div>
      </article>
    );
  };
  return (
    <>
      {cardRows?.map((fields, index) => (
        <div key={index} className={wrapperDivClass}>
          {fields?.fields?.src ? (
            <Link
              href={fields?.fields?.src ? fields?.fields?.src : ""}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:!no-underline"
            >
              {renderCards(fields)}
            </Link>
          ) : (
            renderCards(fields)
          )}
        </div>
      ))}
    </>
  );
};

export default Card;
